/**
 * Переключатель светлой и тёмной темы.
 *
 * Иконка показывает не текущее состояние, а то, куда переключит: солнце в
 * тёмной теме означает «сделать светлее». Показывать текущее состояние в
 * кнопке бессмысленно — оно и так видно по всему экрану.
 */
import { useTranslation } from "react-i18next";

import { useThemeStore } from "../stores/themeStore";

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const theme = useThemeStore((state) => state.theme);
  const toggle = useThemeStore((state) => state.toggle);

  const label = theme === "dark" ? t("theme.toLight") : t("theme.toDark");

  return (
    <button
      type="button"
      className="btn-ghost px-2.5"
      onClick={toggle}
      aria-label={label}
      title={label}
    >
      {theme === "dark" ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}

function SunIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden>
      <circle cx="12" cy="12" r="4" />
      <path
        d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden>
      <path d="M20 13.5A8 8 0 0 1 10.5 4a8 8 0 1 0 9.5 9.5z" strokeLinejoin="round" />
    </svg>
  );
}
